import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackProductInformationVisible = () => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Product long description',
      event_action: 'Impression',
      event_label: 'not set',
    }),
  );
};
